import { get, post } from './http-calls';
import { memoize } from 'lodash';

export const getAllBranch = async () => {
    let res = await get(`/Branches`, { useAuthToken: true });
    return res;
};

export const getBranchById = async (id) => {
    let res = await get(`/Branches/${id}`, { useAuthToken: true });
    return res;
};

export const postBranchData = async (data) => {
    let res = await post(`Branches/SetStampImage`, data, { useAuthToken: true });
    return res;
};

export const postJobLock_Save = async (headerRecordId, workflowID) => {
    let res = await post(`WorkflowJobs/JobLock_Save?headerRecordId=${headerRecordId}&WorkflowID=${workflowID}`, {}, { useAuthToken: true });
    return res;
};

export const postResetJobLock_Save = async () => {
    let res = await post(`WorkflowJobs/JobLock_Save`, {}, { useAuthToken: true });
    return res;
};

export const postReleaseJobLock_Save = async (headerRecordId) => {
    let res = await post(`JobLocks/JobLocks_ResetLock?Id=${headerRecordId}`, {}, { useAuthToken: true });
    return res;
};

export const getBranchAndFranchise = async (id) => {
    let res = await get(`/WorkflowGridDropdown`, { useAuthToken: true });
    return res;
};

export const getBudgetDropDown = async (id) => {
    let res = await get(`Budgets/ScreenDropDown`, { useAuthToken: true });
    return res;
};

export const getBudgetExpenses = async (year, departmentID, branchCode) => {
    let res = await get(`Budgets/GetExpenses?Year=${year}&ID=${departmentID}&BranchID=${branchCode}`, { useAuthToken: true });
    return res;
};

export const getBudgetOtherIncomes = async (year, departmentID, branchCode) => {
    let res = await get(`Budgets/GetOtherIncomes?Year=${year}&ID=${departmentID}&BranchID=${branchCode}`, { useAuthToken: true });
    return res;
};
export const getSalesTargets = async (year, departmentID, branchCode) => {
    let res = await get(`Budgets/GetSalesTargets?Year=${year}&ID=${departmentID}&BranchID=${branchCode}`, { useAuthToken: true });
    return res;
};

export const setSalesTargets = async (data) => {
    let res = await post(`Budgets/SetSalesTargets`, data, { useAuthToken: true });
    return res;
};
export const postBudgetExpenceData = async (data) => {
    let res = await post(`Budgets`, data, { useAuthToken: true });
    return res;
};
export const postSetOtherIncomes = async (data) => {
    let res = await post(`Budgets/SetOtherIncomes`, data, { useAuthToken: true });
    return res;
};

export const AddExpenseCategory = async (data) => {
    let res = await post(`Budgets/AddExpenseCategory`, data, { useAuthToken: true });
    return res;
};

export const AddOtherIncomeCategory = async (data) => {
    let res = await post(`Budgets/AddOtherIncomeCategory`, data, { useAuthToken: true });
    return res;
};

export const getBranchCodes = async (id) => {
    let res = await get(`Branches/BranchCodes/${id}`, { useAuthToken: true });
    return res;
};

export const setBranchCodes = async (data) => {
    let res = await post(`Branches/BranchCodes`, data, { useAuthToken: true });
    return res;
};
export const getReportingTypeList = memoize(async (data) => {
    let res = await get(`Branches/BranchCodesScreenDropdowns`, { useAuthToken: true });
    return res;
});
